var map = {
	"./Telegram-green.svg": 14688,
	"./Telegram.svg": 29618,
	"./VK.svg": 45698,
	"./add-card.svg": 11943,
	"./arrow-back.svg": 26,
	"./arrow-big.svg": 3039,
	"./arrow-btn.svg": 7241,
	"./arrow-down.svg": 1819,
	"./arrow-green.svg": 95376,
	"./arrow-l.svg": 72789,
	"./arrow-lang.svg": 67331,
	"./arrow-line.svg": 27881,
	"./arrow-r.svg": 38643,
	"./arrow-recom.svg": 41875,
	"./arrow-ref.svg": 29938,
	"./arrow-select.svg": 36963,
	"./arrow-up.svg": 35636,
	"./arrow.svg": 89090,
	"./cart.svg": 30141,
	"./check-done.svg": 79650,
	"./check-item.svg": 40919,
	"./check.svg": 62901,
	"./close-card.svg": 25824,
	"./close.svg": 40545,
	"./coin-green.svg": 97646,
	"./coin-white.svg": 34652,
	"./coins.svg": 16359,
	"./cooking.svg": 59813,
	"./cross.svg": 62169,
	"./delivery.svg": 76911,
	"./devices.svg": 83840,
	"./devices_sm.svg": 45711,
	"./dishes.svg": 41179,
	"./exit.svg": 60223,
	"./favourite_empty_icon.svg": 45050,
	"./favourite_filled_icon.svg": 88641,
	"./filter.svg": 73701,
	"./gray-cross.svg": 71977,
	"./gray-search.svg": 75283,
	"./halal-white.svg": 93289,
	"./halal.svg": 18677,
	"./home.svg": 19050,
	"./i.svg": 22692,
	"./icon-check-green.svg": 43973,
	"./icon-check.svg": 44259,
	"./icon-close.svg": 76567,
	"./line-m.svg": 69635,
	"./line.svg": 86389,
	"./logo-tulpan.svg": 7347,
	"./logo-white.svg": 75282,
	"./logo.svg": 69622,
	"./logo_daily.svg": 36532,
	"./mute.svg": 72660,
	"./phone.svg": 39165,
	"./play.svg": 22113,
	"./points.svg": 50466,
	"./rooms/childish.svg": 72334,
	"./rooms/coworking.svg": 35959,
	"./rooms/prayer-room.svg": 81135,
	"./rooms/tea-room.svg": 74686,
	"./search.svg": 45539,
	"./select-check.svg": 6904,
	"./select-down.svg": 428,
	"./select-green.svg": 74001,
	"./select-white.svg": 26375,
	"./select.svg": 52903,
	"./tableware.svg": 89990,
	"./tg.svg": 26764,
	"./ticoin.svg": 87749,
	"./trash.svg": 41663,
	"./truck.svg": 16168,
	"./update-green.svg": 7830,
	"./update.svg": 52180,
	"./user.svg": 99118,
	"./volume.svg": 11965,
	"./ws.svg": 73293
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 77665;